module.exports = __webpack_public_path__ + "static/media/productImg6.43ee6baa.png";